import React from 'react';
import BridgeBrawlLogo from './BridgeBrawlLogo';

const LoadingScreen = () => {
  return (
    <div data-nosnippet style={{
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        background: 'radial-gradient(circle at 10% 20%, #7e6cd9 0%, #4a32e1 90%)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999, color: 'white'
    }}>
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'radial-gradient(circle at 10% 20%, #7e6cd9 0%, #4a32e1 90%)',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, color: 'white'
        }}>
            <div style={{animation: 'pulse 1.5s infinite ease-in-out'}}>
                <BridgeBrawlLogo width={150} />
            </div>
            <div style={{marginTop: 20, fontWeight: 'bold', fontSize: 18, letterSpacing: 1}}>
                LOADING...
            </div>
            <style>{`
                @keyframes pulse {
                    0% { transform: scale(0.95); opacity: 0.8; }
                    50% { transform: scale(1.05); opacity: 1; }
                    100% { transform: scale(0.95); opacity: 0.8; }
                }
            `}</style>
        </div>
    </div>
  );
};

export default LoadingScreen;